import { useContext, useState, useEffect } from "react";
import { MainContext } from "../../contexts/main";
import { BillingFormContext } from "../../contexts/billingForm";
import { isPayable, requiresSalesContact } from "../../helpers/billing";
import { getText } from '@educaplay/app-core/language';
import { SVG_shoppingBag, SVG_corg } from "../elements/SVG";
import { BlockInfoLicense } from "./BlockInfoLicense";
import { BlockLoading } from "./BlockLoading";
import config from "../../resources/config.json";
import { BlockPrices } from "./BlockPrices";
import { getURL } from "../../helpers/urls";
import { TeamPlanContact } from "./TeamPlanContact";
import { BlockAcceptConditions } from "./BlockAcceptConditions";

export const BlockPayAction = ({ handleBuy }) => {
  const { mainReducer, appReducer, environment } = useContext(MainContext);
  const billingForm = useContext(BillingFormContext);

  const [stateVisible, setStateVisible] = useState(false);
  const [stateNeedAuthorization, setStateNeedAuthorization] = useState(false);
  const [stateGeneratingBudget, setStateGeneratingBudget] = useState(false);

  useEffect(() => {
    if (
      mainReducer.state.newPaymentMethod === false &&
      mainReducer.state.currentPaymentMethod.id ==
        mainReducer.state.selectedPaymentMethod &&
      mainReducer.state.user.email !=
        mainReducer.state.currentPaymentMethod.payer
    ) {
      setStateNeedAuthorization(true);
    } else {
      setStateNeedAuthorization(false);
    }
  }, [
    mainReducer.state.selectedPaymentMethod,
    mainReducer.state.newPaymentMethod,
    mainReducer.state.currentPaymentMethod,
  ]);

  useEffect(() => {
    if (isPayable(mainReducer, billingForm.methods.formState.isDirty)) {
      setStateVisible(true);
    } else {
      setStateVisible(false);
    }
  }, [
    mainReducer.state.selectedLicense,
    mainReducer.state.currentLicense,
    mainReducer.state.selectedPaymentMethod,
    mainReducer.state.currentPaymentMethod,
    mainReducer.state.newPaymentMethod,
    billingForm.methods.formState.isDirty,
  ]);

   const handleOpenTeamPlan = (planId, numPlans) => {
    const url = getURL(environment, 'teamPlan') + '?id=' + planId + '&numplans=' + numPlans;
    window.open(url, '_blank').focus();
  }

  const handleValidateAndBuy = async () => {
    if (requiresSalesContact(mainReducer)) {
      const url = getURL(environment, "teamPlan");
      window.open(url, "_blank").focus();
      return;
    }

    if (!billingForm.wantsAnInvoice) {
      handleBuy();
      return;
    }

    setStateGeneratingBudget(true);

    const validation = await billingForm.triggerValidation();

    if (!validation.valid) {
      setStateGeneratingBudget(false);

      if (
        validation.error &&
        validation.error.includes("Formulario con errores")
      ) {
        appReducer.dispatch({
          type: "setNotifications",
          payload: [
            {
              type: "error",
              content: getText("notification_empty_billing"),
            },
          ],
        });
      } else if (validation.error) {
        appReducer.dispatch({
          type: "setNotifications",
          payload: [
            {
              type: "error",
              content: validation.error,
            },
          ],
        });
      }
      return;
    }

    setStateGeneratingBudget(false);
    handleBuy();
  };

  if (stateVisible) {
    return (
      <>
        <div
          className={`e__plns__cta e__plns__cta--${mainReducer.state.selectedLicense.id}${config.plans[mainReducer.state.selectedLicense.id].highlight ? " e__plns__cta--highlight" : ""}`}
        >
          {(mainReducer.state.selectedLicense.id !=
            mainReducer.state.currentLicense.id ||
            mainReducer.state.selectedLicense.periodicity !=
              mainReducer.state.currentLicense.periodicity ||
            mainReducer.state.selectedLicense.licenses !=
              mainReducer.state.currentLicense.licenses) && (
            <>
              <BlockInfoLicense license={mainReducer.state.selectedLicense} />
              {!requiresSalesContact(mainReducer) && (
                <>
                  <BlockPrices
                    licenseId={mainReducer.state.selectedLicense.id}
                  />
                  <BlockAcceptConditions />
                </>
              )}
            </>
          )}
          {!requiresSalesContact(mainReducer) ? (
            <>
              {mainReducer.state.paymentMethods === false ||
              mainReducer.state.countries === false ||
              stateGeneratingBudget ? (
                <BlockLoading />
              ) : (
                <div className="e__plns__cta__btn">
                  <button
                    className="e-btn e-btn--premium e-btn--lg"
                    onClick={handleValidateAndBuy}
                  >
                    <span className="e-icon">
                      {mainReducer.state.currentLicense.id == 0 ? (
                        <SVG_shoppingBag />
                      ) : (
                        <SVG_corg />
                      )}
                    </span>
                    <span className="e-btn__txt">
                      {getText(
                        mainReducer.state.inProgressLicense.id == 0
                          ? "confirmar_suscripcion"
                          : stateNeedAuthorization
                            ? "solicitar_cambio"
                            : mainReducer.state.currentLicense.id == 0
                              ? mainReducer.state.ratesApplied[
                                    mainReducer.state.selectedLicense.id
                                  ].totalNow == 0
                                ? "suscribirse"
                                : "confirmar_suscripcion"
                              : mainReducer.state.ratesApplied[
                                    mainReducer.state.selectedLicense.id
                                  ].totalNow == 0
                                ? "cambiar_suscripcion"
                                : "cambiar_suscripcion_y_pagar",
                      )}
                    </span>
                  </button>
                </div>
              )}{" "}
            </>
          ) : (
            <div className="py-lg">
            <TeamPlanContact
              planId={mainReducer.state.selectedLicense.id}
              numPlans={mainReducer.state.selectedLicense.licenses}
              handleOpenTeamPlan={handleOpenTeamPlan}
            />
            </div>
          )}
        </div>
      </>
    );
  } else {
    return <></>;
  }
};
